module.exports = __webpack_public_path__ + "static/dagny-italic-0c2ff7208765ecc7e4b3dce7520ee328.woff";